import type { HealthRecord } from "../types";
import { localDateKey } from "./records";

export interface RecordDayGroup {
  date: string;
  records: HealthRecord[];
}

export function groupRecordsByLocalDay(records: HealthRecord[]): RecordDayGroup[] {
  const groups = new Map<string, HealthRecord[]>();
  for (const record of records) {
    const date = localDateKey(new Date(record.recordedAt));
    const group = groups.get(date);
    if (group) group.push(record);
    else groups.set(date, [record]);
  }
  return [...groups].map(([date, groupedRecords]) => ({ date, records: groupedRecords }));
}
